import React, { type ButtonHTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";
import BaseButton from "../baseButton";

interface IBaseDarkButton {}

type TBaseDarkButtonProps = IBaseDarkButton &
  ButtonHTMLAttributes<HTMLButtonElement>;

const BaseDarkButton: React.FC<TBaseDarkButtonProps> = (props) => {
  const { children, className, ...otherProps } = props;

  return (
    <BaseButton
      className={twMerge(
        "bg-mainDark border-mainYellow hover:border-mainYellow hover:bg-mainDark hover:bg-opacity-40 text-mainYellow",
        className,
      )}
      minWidth="w-full"
      {...otherProps}
    >
      {children}
    </BaseButton>
  );
};

export default BaseDarkButton;
